import Vue from 'vue'
import VueI18n, { LocaleMessages } from 'vue-i18n'

Vue.use(VueI18n)

function loadLocaleMessages(): LocaleMessages {
	const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
	const messages: LocaleMessages = {}
	locales.keys().forEach((key) => {
		const matched = key.match(/([A-Za-z0-9-_]+)\./i)
		if (matched && matched.length > 1) {
			const locale = matched[1]
			messages[locale] = locales(key)
		}
	})
	return messages
}

function getUrlParameter(name: string): string {
	const regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
	const results = regex.exec(location.search)
	return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
}

function getBrowserLocale(): string {
	const browserLang = navigator.language || (navigator as any).userLanguage
	// Extract the language code (e.g., 'it' from 'it-IT')
	const langCode = browserLang.split('-')[0].toLowerCase()

	// List of supported languages
	const supportedLocales = ['it', 'en', 'es', 'fr', 'de', 'pt']

	// Return the language if supported, otherwise fallback to 'it'
	return supportedLocales.includes(langCode) ? langCode : 'it'
}

function getInitialLocale(): string {
	// List of supported languages
	const supportedLocales = ['it', 'en', 'es', 'fr', 'de', 'pt']

	// Priority 1: URL parameter lang=xx
	const urlLang = getUrlParameter('lang')
	if (urlLang && supportedLocales.includes(urlLang.toLowerCase())) {
		return urlLang.toLowerCase()
	}

	// Priority 2: Browser language
	const browserLocale = getBrowserLocale()
	if (supportedLocales.includes(browserLocale)) {
		return browserLocale
	}

	// Priority 3: Fallback to Italian
	return 'it'
}

export default new VueI18n({
	locale: getInitialLocale(),
	fallbackLocale: 'it',
	messages: loadLocaleMessages()
})
